<template>
  <div class="withdraw-record-page">
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item label="审核状态">
          <el-select v-model="searchForm.status" placeholder="全部" clearable style="width: 140px;">
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="已通过" :value="1"></el-option>
            <el-option label="已拒绝" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="群昵称">
          <el-input v-model="searchForm.groupNickname" placeholder="请输入群昵称" clearable style="width: 140px;"></el-input>
        </el-form-item>
        <el-form-item label="收款人">
          <el-input v-model="searchForm.realName" placeholder="请输入收款人" clearable style="width: 140px;"></el-input>
        </el-form-item>
        <el-form-item label="银行账号">
          <el-input v-model="searchForm.bankAccount" placeholder="请输入银行账号" clearable style="width: 160px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <div slot="header" class="clearfix">
        <span class="card-title">提现记录列表</span>
        <div style="float: right;">
          <el-button type="success" size="small" icon="el-icon-check" @click="handleBatchApprove" :disabled="selectedRows.length === 0">批量通过</el-button>
          <el-button type="warning" size="small" icon="el-icon-download" @click="handleExport">导出列表</el-button>
        </div>
      </div>

      <el-table :data="tableData" v-loading="tableLoading" stripe border height="calc(100vh - 280px)" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50" align="center" :selectable="checkSelectable"></el-table-column>
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="applyNo" label="申请单号" width="200"></el-table-column>
        <el-table-column label="群昵称" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatGroupNickname(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="totalAmount" label="提现金额" width="120" align="right">
          <template slot-scope="scope">
            <span class="amount">¥{{ scope.row.totalAmount != null ? scope.row.totalAmount : '0.00' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="couponName" label="优惠券" width="120" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.couponName" class="coupon-tag">{{ scope.row.couponName }}</span>
            <span v-else class="no-coupon">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="discountAmount" label="优惠券金额" width="110" align="right">
          <template slot-scope="scope">
            <span v-if="scope.row.discountAmount && scope.row.discountAmount > 0" class="bonus">+¥{{ scope.row.discountAmount }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderCount" label="关联订单数" width="100" align="center"></el-table-column>
        <el-table-column prop="status" label="审核状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.status)" size="small">
              {{ getStatusName(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="rejectReason" label="拒绝原因" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="remark" label="用户备注" min-width="120" show-overflow-tooltip></el-table-column>
        <el-table-column prop="realName" label="收款人" width="100" align="center"></el-table-column>
        <el-table-column prop="bankName" label="开户银行" width="140" align="center"></el-table-column>
        <el-table-column prop="bankAccount" label="银行账号" width="200" align="center">
          <template slot-scope="scope">
            {{ scope.row.bankAccount || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="申请时间" width="180">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.applyTime) }}
          </template>
        </el-table-column>
        <el-table-column label="审核时间" width="180">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.auditTime) || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
            <el-button type="text" size="small" @click="handleApprove(scope.row)" v-if="scope.row.status === 0" style="color: #67C23A;">通过</el-button>
            <el-button type="text" size="small" @click="handleReject(scope.row)" v-if="scope.row.status === 0" style="color: #F56C6C;">拒绝</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="pagination.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 查看详情弹窗 -->
    <el-dialog title="提现记录详情" :visible.sync="viewDialogVisible" width="800px">
      <el-descriptions :column="2" border v-if="viewData">
        <el-descriptions-item label="申请单号" :span="2">{{ viewData.applyNo }}</el-descriptions-item>
        <el-descriptions-item label="群昵称">{{ formatGroupNickname(viewData) }}</el-descriptions-item>
        <el-descriptions-item label="提现金额">
          <span class="amount">¥{{ viewData.totalAmount != null ? viewData.totalAmount : '0.00' }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="优惠券" v-if="viewData.couponName">
          <span class="coupon-tag">{{ viewData.couponName }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="优惠券金额" v-if="viewData.discountAmount && viewData.discountAmount > 0">
          <span class="bonus">+¥{{ viewData.discountAmount }}</span>
        </el-descriptions-item>
        <el-descriptions-item label="关联订单数">{{ viewData.orderCount }}</el-descriptions-item>
        <el-descriptions-item label="审核状态">
          <el-tag :type="getStatusTagType(viewData.status)" size="small">
            {{ getStatusName(viewData.status) }}
          </el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="拒绝原因" v-if="viewData.rejectReason">{{ viewData.rejectReason }}</el-descriptions-item>
        <el-descriptions-item label="用户备注" :span="2">{{ viewData.remark || '-' }}</el-descriptions-item>
        <el-descriptions-item label="收款人">{{ viewData.realName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="开户银行">{{ viewData.bankName || '-' }}</el-descriptions-item>
        <el-descriptions-item label="银行账号">{{ viewData.bankAccount || '-' }}</el-descriptions-item>
        <el-descriptions-item label="申请时间">{{ formatDateTime(viewData.applyTime) }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{ formatDateTime(viewData.auditTime) || '-' }}</el-descriptions-item>
      </el-descriptions>

      <!-- 关联订单列表 -->
      <div v-if="viewData && viewData.orderList && viewData.orderList.length > 0" class="order-list">
        <h4 class="order-list-title">关联订单</h4>
        <el-table :data="viewData.orderList" border size="small">
          <el-table-column prop="id" label="订单ID" width="80"></el-table-column>
          <el-table-column prop="title" label="标题" min-width="150"></el-table-column>
          <el-table-column prop="phone" label="手机号" width="130"></el-table-column>
          <el-table-column prop="balanceAmount" label="尾款金额" width="110" align="right">
            <template slot-scope="scope">
              <span class="amount">¥{{ scope.row.balanceAmount != null ? scope.row.balanceAmount : '0.00' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="orderStatusName" label="订单状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="getOrderStatusTagType(scope.row.orderStatus)" size="small">
                {{ scope.row.orderStatusName }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="withdrawStatus" label="提现状态" width="90" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.withdrawStatus === 1 ? 'success' : 'info'" size="small">
                {{ scope.row.withdrawStatus === 1 ? '已提现' : '未提现' }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer">
        <el-button type="primary" @click="viewDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 拒绝弹窗 -->
    <el-dialog title="拒绝提现申请" :visible.sync="rejectDialogVisible" width="500px" @close="handleRejectDialogClose">
      <el-form :model="rejectForm" :rules="rejectRules" ref="rejectFormRef" label-width="100px">
        <el-form-item label="拒绝原因" prop="reason">
          <el-input v-model="rejectForm.reason" type="textarea" :rows="4" placeholder="请输入拒绝原因" maxlength="255" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="rejectDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleRejectSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getWithdrawList,
  getWithdraw,
  approveWithdraw,
  rejectWithdraw,
  deleteWithdraw,
  batchApproveWithdraw,
  exportWithdrawList
} from '@/api/index'

export default {
  name: 'WithdrawRecordManagement',
  data() {
    return {
      searchForm: {
        status: null,
        groupNickname: '',
        realName: '',
        bankAccount: ''
      },
      tableData: [],
      tableLoading: false,
      selectedRows: [],
      selectedIds: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      // view dialog
      viewDialogVisible: false,
      viewData: null,
      // reject dialog
      rejectDialogVisible: false,
      submitLoading: false,
      _rejectRecordId: null,
      rejectForm: {
        reason: ''
      },
      rejectRules: {
        reason: [{ required: true, message: '请输入拒绝原因', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    formatGroupNickname(row) {
      if (!row) return '-'
      const nickname = row.groupNickname != null ? String(row.groupNickname).trim() : ''
      if (nickname) return nickname
      return row.userName || '-'
    },

    formatDateTime(value) {
      if (!value) return '-'
      const s = String(value).trim()
      if (!s) return '-'
      return s.replace('T', ' ').slice(0, 19)
    },

    getStatusTagType(status) {
      const map = { 0: 'warning', 1: 'success', 2: 'danger' }
      return map[status] || 'info'
    },

    getStatusName(status) {
      const map = { 0: '待审核', 1: '已通过', 2: '已拒绝' }
      return map[status] || '未知'
    },

    getOrderStatusTagType(status) {
      const map = { 0: 'info', 1: 'warning', 6: 'primary', 2: 'danger', 3: 'warning', 4: 'warning', 5: 'success' }
      return map[status] || 'info'
    },

    async loadData() {
      this.tableLoading = true
      try {
        const params = {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          status: this.searchForm.status,
          groupNickname: this.searchForm.groupNickname,
          realName: this.searchForm.realName,
          bankAccount: this.searchForm.bankAccount
        }
        const res = await getWithdrawList(params)
        this.tableData = res.data?.list || []
        this.pagination.total = res.data?.total || 0
      } catch (e) {
        console.error('加载数据失败', e)
      } finally {
        this.tableLoading = false
      }
    },

    handleSearch() {
      this.pagination.pageNum = 1
      this.loadData()
    },

    handleReset() {
      this.searchForm = { status: null, groupNickname: '', realName: '', bankAccount: '' }
      this.pagination.pageNum = 1
      this.loadData()
    },

    handlePageChange(page) {
      this.pagination.pageNum = page
      this.loadData()
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageNum = 1
      this.loadData()
    },

    async handleView(row) {
      try {
        const res = await getWithdraw(row.id)
        this.viewData = res.data
        this.viewDialogVisible = true
      } catch (e) {
        this.$message.error('获取详情失败')
      }
    },

    handleApprove(row) {
      this.$confirm(`确定要通过该提现申请吗？通过后关联订单状态将更新为"交易完成"，提现状态更新为"已提现"。`, '审核确认', {
        confirmButtonText: '确定通过',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await approveWithdraw(row.id)
          this.$message.success('审核通过')
          this.loadData()
        } catch (e) {
          console.error(e)
        }
      }).catch(() => {})
    },

    handleReject(row) {
      this._rejectRecordId = row.id
      this.rejectForm.reason = ''
      this.rejectDialogVisible = true
    },

    handleRejectDialogClose() {
      this.$refs.rejectFormRef && this.$refs.rejectFormRef.resetFields()
    },

    handleRejectSubmit() {
      this.$refs.rejectFormRef.validate(async (valid) => {
        if (!valid) return
        this.submitLoading = true
        try {
          await rejectWithdraw(this._rejectRecordId, this.rejectForm.reason)
          this.$message.success('已拒绝')
          this.rejectDialogVisible = false
          this.loadData()
        } catch (e) {
          console.error(e)
        } finally {
          this.submitLoading = false
        }
      })
    },

    handleSelectionChange(selection) {
      this.selectedRows = selection
      this.selectedIds = selection.map(row => row.id)
    },

    checkSelectable(row) {
      return row.status === 0
    },

    handleBatchApprove() {
      if (this.selectedIds.length === 0) return
      this.$confirm(`确定要批量通过选中的 ${this.selectedIds.length} 条提现申请吗？`, '批量审核确认', {
        confirmButtonText: '确定通过',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await batchApproveWithdraw(this.selectedIds)
          this.$message.success(`批量审批成功，共通过 ${this.selectedIds.length} 条记录`)
          this.selectedRows = []
          this.selectedIds = []
          this.loadData()
        } catch (e) {
          console.error(e)
        }
      }).catch(() => {})
    },

    async handleExport() {
      try {
        const res = await exportWithdrawList()
        // request 拦截器对 CSV 返回 { __blob: axiosResponse }，须取 data，否则会变成 [object Object]
        const raw = res.__blob && res.__blob.data != null ? res.__blob.data : res
        const blob = new Blob([raw], { type: 'text/csv;charset=UTF-8' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        const filename = `提现记录_${new Date().toISOString().slice(0, 19).replace(/[T:]/g, '')}.csv`
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error('导出失败')
        console.error(e)
      }
    },

    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除该提现记录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await deleteWithdraw(row.id)
        this.$message.success('删除成功')
        this.loadData()
      } catch (e) {
        if (e !== 'cancel') {
          this.$message.error('删除失败')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.withdraw-record-page {
  padding: 20px;
}

.search-card {
  margin-bottom: 16px;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.amount {
  color: #F56C6C;
  font-weight: 500;
}

.coupon-tag {
  display: inline-block;
  padding: 2px 8px;
  background: linear-gradient(135deg, #FFF5E6 0%, #FFE4C4 100%);
  border: 1px solid #FF8C00;
  border-radius: 4px;
  color: #FF8C00;
  font-size: 12px;
}

.no-coupon {
  color: #C0C4CC;
}

.bonus {
  color: #67C23A;
  font-weight: 500;
}

.order-list {
  margin-top: 20px;

  .order-list-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 12px;
  }
}
</style>
